import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/laceData';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="mx-auto px-4 md:px-6 py-14 md:py-20" style={{ maxWidth: '1280px' }}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          <div>
            <h4 className="font-heading text-lg font-semibold text-background-50 mb-4">
              {siteInfo.name}
            </h4>
            <p className="text-sm leading-relaxed text-background-400 mb-6">
              {siteInfo.tagline}<br />
              探索蕾丝的无限魅力，让经典优雅融入生活。
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="小红书">
                <i className="ri-link-m text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">蕾丝分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快捷链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  品牌故事
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  用户口碑
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">订阅资讯</h4>
            <p className="text-sm text-background-400 mb-4">
              订阅我们的资讯邮件，第一时间获取蕾丝新品发布和穿搭灵感。
            </p>
            {subscribed ? (
              <p className="text-sm text-accent-400 font-medium">
                <i className="ri-check-line mr-1"></i>订阅成功！感谢您的关注。
              </p>
            ) : (
              <form onSubmit={handleSubscribe} className="flex gap-0">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入您的邮箱"
                  required
                  className="flex-1 px-4 py-2.5 text-sm bg-background-800 border border-background-700 text-background-50 placeholder:text-background-500 outline-none rounded-l-md focus:border-primary-500 transition-colors duration-200"
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-r-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  订阅
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}